export default theme => ({
  card: {
    textDecoration: 'none',
    '& .MuiCardContent-root': {
      padding: theme.spacing(2)
    },
    '& .MuiTypography-h6': {
      marginBottom: 0,
      fontSize: '1.1rem'
    }
  },
  grid: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1)
  },
  buttonNew: {
    float: 'right'
  },
  more: {
    float: 'right'
  },
  doNotShow: {
    opacity: 0
  }
});
